import QuestionCheckbox from "./QuestionCheckbox";
import QuestionDateInput from "./QuestionDateInput";
import QuestionDocumentMultiple from "./QuestionDocumentMultiple";
import QuestionErrorMessage from "./QuestionErrorMessage";
import QuestionGroup from "./QuestionGroup";
import QuestionInput from "./QuestionInput";
import QuestionLabel from "./QuestionLabel";
import QuestionParagraph from "./QuestionParagraph";
import QuestionPhoneNumberInput from "./QuestionPhoneNumberInput";
import QuestionPlaceholder from "./QuestionPlaceholer";
import QuestionRadio from "./QuestionRadio";
import QuestionSelect from "./QuestionSelect";
import QuestionSSNInput from "./QuestionSSNInput";
import QuestionVideo from "./QuestionVideo";
import QuestionWrapper from "./QuestionWrapper";

export default {
  Label: QuestionLabel,
  ErrorMessage: QuestionErrorMessage,
  Input: QuestionInput,
  Checkbox: QuestionCheckbox,
  Radio: QuestionRadio,
  Select: QuestionSelect,
  Group: QuestionGroup,
  Paragraph: QuestionParagraph,
  Section: QuestionWrapper,
  Placeholder: QuestionPlaceholder,
  Document: QuestionDocumentMultiple,
  Date: QuestionDateInput,
  PhoneNumber: QuestionPhoneNumberInput,
  SSN: QuestionSSNInput,
  Video: QuestionVideo,
};
